<template>
  <b-modal
    title="QUESTÕES P/ ACESSO OFFLINE"
    id="security_questions"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
    no-close-on-backdrop
  >
    <b-form @submit.prevent="evOnSubmit">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <WarningMessage
            class="text-thirteen"
            message="As questões abaixo serão necessárias para efetuar o acesso OFFLINE."
          />
          <label-required-field
            class="text-fourteen mb-1 upper-text weight-600"
            label="1ª Pergunta"
          />
          <b-select
            :options="first_questions"
            text-field="statement"
            value-field="id"
            v-model="first_security_question_id"
            @change="filterFirstQuestions"
          />

          <label-required-field
            class="text-fourteen mb-0 mt-2 upper-text weight-600"
            label="Resposta:"
          />
          <b-input-password ref="autofocus" v-model="first_answer" />
          <hr class="mt-0" />
          <label-required-field
            class="text-fourteen mb-1 upper-text weight-600"
            label="2ª Pergunta"
          />
          <b-select
            :options="last_questions"
            text-field="statement"
            value-field="id"
            v-model="last_security_question_id"
            @change="filterLastQuestions"
          />
          <label-required-field
            class="text-fourteen mb-0 mt-2 upper-text weight-600"
            label="Resposta:"
          />
          <b-input-password v-model="last_answer" />
          <ErrorsMessages :errors="errors" />
          <WarningRequiredFields />
          <v-btn
            @click="$bvModal.hide('security_questions')"
            class="btn-cancel"
            :disabled="loading"
            >CANCELAR
          </v-btn>
          <v-btn class="btn-save float-right" type="submit" :disabled="loading">
            <i class="fas fa-save mr-2 text-twenty" /> SALVAR
          </v-btn>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { getStatic } from "../../lib/functions";
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";
import WarningMessage from "../Components/WarningMessage";
import BInputPassword from "../Components/BInputPassword.vue";

export default {
  name: "SecurityQuestions",
  components: {
    WarningRequiredFields,
    LabelRequiredField,
    WarningMessage,
    ErrorsMessages,
    BInputPassword,
  },
  data() {
    return {
      errors: [],
      loading: false,

      security_questions: [],
      first_questions: [],
      last_questions: [],

      first_security_question_id: "",
      last_security_question_id: "",
      first_answer: "",
      last_answer: "",

      /**@type {{
       * user_id: number,
       * first_security_question_id: number,
       * first_answer: string,
       * last_security_question_id: number,
       * last_answer: string}
       * } */
      security_question_answer: {},
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      try {
        this.security_questions = (
          await getStatic("/default/security-questions", true)
        ).security_questions;
      } catch (errors) {
        this.errors = errors;
        return;
      }

      await this.filterFirstQuestions();
      await this.filterLastQuestions();
    },

    async evOnShow() {
      this.loading = true;

      try {
        const response = await api.get(
          "/rest-home/user/security-question-answer"
        );
        const { error, errors, security_question_answer } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.first_security_question_id =
            security_question_answer.first_security_question_id;
          this.last_security_question_id =
            security_question_answer.last_security_question_id;
          this.first_answer = security_question_answer.first_answer;
          this.last_answer = security_question_answer.last_answer;
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      this.loading = true;

      try {
        const data = {
          first_security_question_id: this.first_security_question_id,
          last_security_question_id: this.last_security_question_id,
          first_answer: this.first_answer,
          last_answer: this.last_answer,
        };
        const response = await api.patch(
          "/rest-home/user/security-question-answer",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("security_questions");
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    async filterFirstQuestions() {
      this.last_questions = this.security_questions.filter(
        (value) => value.id != this.first_security_question_id
      );
    },
    async filterLastQuestions() {
      this.first_questions = this.security_questions.filter(
        (value) => value.id != this.last_security_question_id
      );
    },
  },
};
</script>

<style></style>
